import React from 'react';
import merge from 'lodash/merge';
import Character from './4-Character.jsx';

import introBrett from '../../../flux/introBrett';

const propTypes = {
    backgroundKey: React.PropTypes.string,
    className: React.PropTypes.string,
    onResumeMessageBox: React.PropTypes.func,
    onAnimationReady: React.PropTypes.func,
};

const defaultProps = {
    className: 'intro-brett',
    slideshowKey: 'brettFull',
    backgroundKey: 'kraftBackground',
    layers: [
        {
            backgroundKey: 'lightLinesBackground',
        },
        {
            backgroundKey: 'backgroundStripe',
        },
    ],
    speed: 3,

    onResumeMessageBox: null,
    onAnimationReady: null,
    fps: 2.5,
    fluxSettings: introBrett,
};

class Dave extends Character {

}

Dave.propTypes = propTypes;
Dave.defaultProps = merge({}, Character.defaultProps, defaultProps);

module.exports = Dave;



// WEBPACK FOOTER //
// ./js/components/frames/0-Intro/43-Brett.jsx